import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class Stacks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      baseDiameter: '',
      topDiameter: '',
      height: '',
      amount: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAmount = this.handleChange.bind(null, 'amount');
    this.handleChangeBaseDiameter = this.handleChange.bind(null, 'baseDiameter');
    this.handleChangeHeight = this.handleChange.bind(null, 'height');
    this.handleChangeTopDiameter = this.handleChange.bind(null, 'topDiameter');
  }
  handleChange(key, value) {
    const onCalc = this.props.onCalc;
    this.setState({
      [key]: value
    }, () => {
      const _this$state = this.state,
        baseDiameter = _this$state.baseDiameter,
        topDiameter = _this$state.topDiameter,
        height = _this$state.height,
        amount = _this$state.amount;
      if (baseDiameter !== '' && topDiameter !== '' && height !== '' && amount !== '') {
        // Calculate the surface area
        const base = parseFloat(baseDiameter) || 0;
        const top = parseFloat(topDiameter) || 0;
        const total = 0.5 * (base + top) * 3.14 * height * amount;

        // If it's a valid value, pass it up
        if (!_.isNaN(total)) {
          onCalc(+total.toFixed(2));
        }
      }
    });
  }
  render() {
    const _this$state2 = this.state,
      baseDiameter = _this$state2.baseDiameter,
      topDiameter = _this$state2.topDiameter,
      height = _this$state2.height,
      amount = _this$state2.amount;
    const result = this.props.result;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "3.14 x (Base Diameter + Top Diameter)/2 x Height x Amount = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Base Diameter",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeBaseDiameter,
      value: baseDiameter
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Top Diameter",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeTopDiameter,
      value: topDiameter
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Height",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeHeight,
      value: height
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Amount",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeAmount,
      value: amount
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
Stacks.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};
Stacks.defaultProps = {
  onCalc: null,
  result: null
};